module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "MailAddressChangePanel"
    }
  }, [_c('h1', [_vm._v("メールアドレスの変更")]), _vm._v(" "), _c('label', {
    staticClass: "cate2"
  }, [_vm._v("新しいメールアドレス:\n    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.new_mail_address),
      expression: "new_mail_address"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.new_mail_address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.new_mail_address = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "square_btn",
    on: {
      "click": _vm.changeMailLocal
    }
  }, [_vm._v("メールアドレスを変更")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49c9765a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserInfo/MailAddressChangePanel.vue
// module id = 701
// module chunks = 0